import { cn } from "@/lib/utils";

/*
 * Yopishgan ustun (amallar — o'ngda, belgilash — chapda) keng jadval
 * aylanganda qo'shni kataklar USTIDA turadi, shuning uchun foni NOSHAFFOF
 * bo'lishi shart. Ilgari `bg-inherit` edi: qatorning o'zida fon yo'q (yoki
 * yarim shaffof `hover:bg-muted/50`), ya'ni katak shaffof chiqib, tagidagi
 * narx va holat nishoni ikonkalar bilan ustma-ust ko'rinardi. Endi fon —
 * karta rangi, qator holatlari (hover, tanlangan, joriy) esa o'sha rangga
 * aralashtirilib takrorlanadi.
 *
 * Chegara ham soya bilan chiziladi: `border-collapse` jadvalida yopishgan
 * katakning chegarasi u bilan birga siljimaydi.
 */
export const STICKY_CELL = cn(
  "sticky z-[1] bg-card",
  "group-hover/row:bg-[color-mix(in_oklab,var(--color-muted)_50%,var(--color-card))]",
  "group-has-aria-expanded/row:bg-[color-mix(in_oklab,var(--color-muted)_50%,var(--color-card))]",
  "group-data-[state=selected]/row:bg-muted",
  "group-data-[current=true]/row:bg-highlight",
);

export const STICKY_END_EDGE =
  "shadow-[inset_1px_0_0_var(--color-border),-8px_0_12px_-10px_rgb(0_0_0/0.3)]";
export const STICKY_START_EDGE =
  "shadow-[inset_-1px_0_0_var(--color-border),8px_0_12px_-10px_rgb(0_0_0/0.3)]";
